export default {
    props: { projects: Object },
    computed: {
        
    }, 
    methods:{
      
    }

}